<div class="overlay-medium">
  <app-card-medium title="{{ 'Edit Project' | translate }}">
    <div class="content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div style="overflow: auto" #formContainer>
          <div class="form-group">
            <input
              formControlName="name"
              type="text"
              class="form-control"
              placeholder="{{ 'Location Name' | translate }}"
            />
            <div *ngIf="formName?.invalid" class="text-danger">
              {{ "Name is required" | translate }}
            </div>
          </div>
          <div class="form-group">
            <textarea
              formControlName="description"
              class="form-control"
              rows="3"
              placeholder="{{ 'Description' | translate }}"
            ></textarea>
            <div *ngIf="formDescription?.invalid" class="text-danger">
              {{ "Description is required" | translate }}
            </div>
          </div>
          <!-- <div class="form-group">
            <textarea formControlName="address" class="form-control" rows="3"
              placeholder="{{ 'Address' | translate }}"></textarea>
          </div> -->
          <div style="margin-bottom: 13px">
            <div
              class="input-group"
              style="margin-bottom: 0; padding-bottom: 0"
            >
              <input
                type="text"
                formControlName="coordinate"
                class="form-control"
                placeholder="{{ 'Longitude, Latitude' | translate }}"
              />
              <div class="input-group-append">
                <button
                  *ngIf="!isGetCoor"
                  (click)="getMapLngLat()"
                  class="btn btn-sm btn-primary"
                  type="button"
                >
                  <i class="icon-pointer"></i>
                </button>
                <button
                  *ngIf="isGetCoor"
                  (click)="disableMapClick()"
                  class="btn btn-sm btn-secondary"
                  type="button"
                >
                  <i class="icon-pointer"></i>
                </button>
              </div>
            </div>
            <div
              style="padding-left: 0.3em"
              *ngIf="formCoor?.errors?.required"
              class="text-danger"
            >
              {{ "Coordinate is required" | translate }}
            </div>
            <div
              style="padding-left: 0.3em"
              *ngIf="
                !formCoor?.errors?.required &&
                formCoor?.errors?.coordinateFormat
              "
              class="text-danger"
            >
              {{ "Invalid coordinate format" | translate }}
            </div>
          </div>
          <!-- <div class="input-group">
            <input type="text" formControlName="coordinate" class="form-control" placeholder="{{ 'Longitude, Latitude' | translate }}">
            <div class="input-group-append">
              <button *ngIf="!isGetCoor" (click)="getMapLngLat()" class="btn btn-sm btn-primary" type="button">
                <i class="icon-pointer"></i>
              </button>
              <button *ngIf="isGetCoor" (click)="disableMapClick()" class="btn btn-sm btn-secondary" type="button">
                <i class="icon-pointer"></i>
              </button>
            </div>
          </div> -->
          <!-- <div class="form-group">
            <input formControlName="longitude" type="text" class="form-control"
              placeholder="{{ 'Longitude' | translate }}">
          </div>
          <div class="form-group">
            <input formControlName="latitude" type="text" class="form-control"
              placeholder="{{ 'Latitude' | translate }}">
          </div> -->
          <div class="form-group">
            <input
              formControlName="default_zoom_level"
              type="text"
              class="form-control"
              placeholder="{{ 'Default Zoom Level' | translate }}"
            />
            <small class="form-text text-muted"
              ><small>Current zoom level: {{ currZoomLevel | number }}.</small
              >&nbsp;<span
                class="set-default-zoom badge badge-secondary"
                (click)="setDefaultZoom(currZoomLevel)"
                >Click to set</span
              ></small
            >
          </div>
          <div class="form-group">
            <input
              formControlName="parentName"
              type="text"
              class="form-control"
              placeholder="{{ 'Parent Location' | translate }}"
              (keyup)="searchParent($event)"
            />
            <div #autoComplete class="auto-complete">
              <ul class="list-group">
                <li
                  *ngFor="let parent of parentSelection; trackById"
                  (click)="selectedParent(parent)"
                  class="list-group-item"
                >
                  {{ parent.name }}
                </li>
              </ul>
            </div>
          </div>
          <div class="form-group">
            <select formControlName="status" class="form-control">
              <option value="" disabled>{{ "Status" | translate }}</option>
              <option value="active">{{ "Active" | translate }}</option>
              <option value="inactive">{{ "Inactive" | translate }}</option>
            </select>
          </div>
          <div class="form-group">
            <select formControlName="visibility" class="form-control">
              <option value="" disabled>{{ "Visibility" | translate }}</option>
              <option value="private">{{ "Private" | translate }}</option>
              <option value="public">{{ "Public" | translate }}</option>
            </select>
          </div>

          <div class="form-group">
            <select
              formControlName="generic_type_template"
              class="form-control"
            >
              <option value="" disabled>
                {{ "---Choose generic template---" | translate }}
              </option>
              <option
                *ngFor="let gt of genericTemplates; trackById"
                [value]="gt.id"
              >
                {{ gt.name }}
              </option>
            </select>
          </div>
          <div style="display: flex; justify-content: center">
            <div
              style="
                display: flex;
                width: 100%;
                margin-bottom: 13px;
                align-items: center;
                padding: 0.3em;
              "
            >
              <app-toggle-switch
                [selected]="form.get('ctqrs_enabled').value"
                [forOthers]="true"
                (change)="onToggleChange('ctqrs_enabled')"
              ></app-toggle-switch>
              <p class="m-0 pl-2">{{ "Enable CQTRS" | translate }}</p>
            </div>
          </div>
          <div style="display: flex; justify-content: center">
            <div
              style="
                display: flex;
                width: 100%;
                margin-bottom: 13px;
                align-items: center;
                padding: 0.3em;
              "
            >
              <app-toggle-switch
                [selected]="form.get('show_annotation_marker').value"
                [forOthers]="true"
                (change)="onToggleChange('show_annotation_marker')"
              ></app-toggle-switch>
              <p class="m-0 pl-2">
                {{ "Enable Annotation Marker" | translate }}
              </p>
            </div>
          </div>
          <div style="display: flex; justify-content: center">
            <div
              style="
                display: flex;
                width: 100%;
                margin-bottom: 13px;
                align-items: center;
                padding: 0.3em;
              "
            >
              <app-toggle-switch
                [selected]="form.get('faq_enabled').value"
                [forOthers]="true"
                (change)="onToggleChange('faq_enabled')"
              ></app-toggle-switch>
              <p class="m-0 pl-2">{{ "Enable FAQ Tab" | translate }}</p>
            </div>
          </div>
          <div style="display: flex; justify-content: center">
            <div
              style="
                display: flex;
                width: 100%;
                margin-bottom: 13px;
                align-items: center;
                padding: 0.3em;
              "
            >
              <app-toggle-switch
                [selected]="form.get('show_review_module').value"
                [forOthers]="true"
                (change)="onToggleChange('show_review_module')"
              ></app-toggle-switch>
              <p class="m-0 pl-2">
                {{ "Enable Review Module" | translate }}
              </p>
            </div>
          </div>

          <label>{{ "Additional Info" | translate }}</label>

          <div class="form-row">
            <div class="col-5">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Key"
                  formControlName="additional_data_key"
                />
              </div>
            </div>
            <div class="col">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Value"
                  formControlName="additional_data_val"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-primary btn-sm"
                    type="button"
                    (click)="addAD()"
                  >
                    <i class="icon-create"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="list-group">
            <a
              class="list-group-item list-group-item-action"
              *ngFor="let ad of locAdditionalData; let i = index"
            >
              <div class="d-flex w-100 justify-content-between">
                <div>
                  <p class="mb-1">{{ ad.key }}</p>
                  <small>{{ ad.value }}</small>
                </div>
                <button
                  class="btn btn-sm btn-danger"
                  type="button"
                  (click)="removeAD(i)"
                >
                  <i class="icon-delete"></i>
                </button>
              </div>
            </a>
          </div>
        </div>
        <div class="form-buttons">
          <button type="button" class="btn btn-secondary" backButton>
            {{ "Discard" | translate }}
          </button>
          <button
            type="submit"
            [disabled]="form.invalid"
            class="btn btn-primary"
          >
            {{ "Save" | translate }}
          </button>
        </div>
      </form>
    </div>
  </app-card-medium>
</div>
